module.exports = __webpack_public_path__ + "img/banner.09a94554.jpg";